export default __webpack_public_path__ + "static/cafe_36066-794e95f263ed401eb68ff6555b371137.png";